var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"align-center":""}},[_c('span',{staticClass:"type__color mr-2",style:({'background-color': _vm.color})}),_c('span',[_vm._v(_vm._s(_vm.type.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }